const configuration = {
    oauthScope: "https://www.googleapis.com/auth/userinfo.email"
};

export default configuration;